import styled from 'styled-components';
import { NotificationStatus } from 'modules/notificationCenter/types';
import { SegmentedControlOption } from 'ui/segmentedControl';
import { colors } from 'ui/theme';
import { ORDER_BY_OPTIONS } from './constants';

const UnreadCount = styled.span`
  color: ${colors.textSecondary};
`;

const getUnreadCountText = (unreadCount: number | undefined) => {
  /**
   * Adding the + is only necessary while the Motifications Count endpoint is
   * broken, and we do not have an accurate count. This can be removed once
   * WF-6029 is fixed.
   */
  if (typeof unreadCount === 'number') return unreadCount >= 10 ? '10+' : unreadCount?.toString();
  return '0';
};

export const createStatusOptions = (
  isLoading = false,
  unreadCount: number | undefined,
): SegmentedControlOption[] =>
  [NotificationStatus.UNREAD, NotificationStatus.READ].map((statusValue) => ({
    disabled: !!isLoading,
    key: statusValue,
    name: (
      <p>
        {statusValue}
        {statusValue === NotificationStatus.UNREAD && (
          <UnreadCount>&nbsp;({getUnreadCountText(unreadCount)})</UnreadCount>
        )}
      </p>
    ),
    value: statusValue,
  }));

export const createOrderByOptions = () =>
  Object.values(ORDER_BY_OPTIONS).map((option) => ({
    id: option.displayName,
    label: option.displayName,
    value: option.filterName,
  }));
